import {
  cerrarSwalTramitando,
  mostrarSwalTramitando,
} from "./funcionesSwal";

export async function postJson(url, body, { showLoading = true } = {}) {
  const token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("accessToken") ||
        (typeof sessionStorage !== "undefined" && sessionStorage.getItem("accessToken")) ||
        localStorage.getItem("csrfToken")
      : null;
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (showLoading) mostrarSwalTramitando();
  try {
    let response;
    try {
      response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });
    } catch {
      throw new Error("No se pudo conectar con el servidor.");
    }

    const data = await response.json().catch(() => null);
    if (!response.ok) {
      if (
        response.status === 401 &&
        typeof window !== "undefined" &&
        typeof localStorage !== "undefined" &&
        (localStorage.getItem("accessToken") ||
          (typeof sessionStorage !== "undefined" && sessionStorage.getItem("accessToken")) ||
          localStorage.getItem("csrfToken"))
      ) {
        window.dispatchEvent(new Event("client-session-expired"));
      }
      const error = new Error(
        data && typeof data.message === "string"
          ? data.message
          : `El servidor respondió con el error ${response.status}.`
      );
      error.status = response.status;
      throw error;
    }
    if (!data || typeof data !== "object") {
      throw new Error("El servidor devolvió una respuesta no válida.");
    }

    return data;
  } finally {
    if (showLoading) cerrarSwalTramitando();
  }
}
